<script lang="ts" setup>
	import {useDarkMode} from '@/scripts/composables/use-dark-mode';
	import {Moon, Sun} from 'lucide-vue-next';

	const {isDarkTheme, toggleDarkMode} = useDarkMode();
</script>

<template>
	<Button
		variant="ghost"
		@click="toggleDarkMode()"
	>
		<Moon
			v-show="isDarkTheme"
			class="h-4 w-4"
		/>
		<Sun
			v-show="!isDarkTheme"
			class="h-4 w-4"
		/>
	</Button>
</template>
